import React from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Typography, Button, Grid, TableContainer, Table, TableHead, 
  TableBody, TableRow, Paper, TextareaAutosize, Modal, Select, MenuItem, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import CreatePackage from '../shipment/CreatePackage'
import legolasApi from '../../api/legolas'
import { has } from 'lodash'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function AddInvoice() {
 // const { state : { data, type } } = useLocation()
  const location = useLocation();
 const data = location?.state?.data || null;
 const type = location?.state?.type || null;

  console.log("Page Data", data);
  const { items, shipment, summary, transaction, customer } = data
  const navigate = useNavigate()
  const [pageType, setPageType] = React.useState('invoice')
  const [openPackage, setOpenPackage] = React.useState(false)
  const [packageDetails, setPackageDetails] = React.useState({})
  const [shippingPartnerId, setShippingPartnerId] = React.useState(1)
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')

  React.useEffect(() => {
    if (type === 'shipment') {
      setPageType('shipment')
    }
    if (summary && summary.shippingId) {
      setShippingPartnerId(summary.shippingId)
    }
  },[])

  const backClickHandler = () => {
    const orderId = summary['order_id']
    const redirectUrl = `/orders/${orderId}`
    navigate(redirectUrl)
  }

  const darkBox = {
    width: '96%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '96%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#fff',
    padding: '10px'
  }

  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }

  const handleInvoiceorShipmentSubmit = async () => {
    if (pageType === 'shipment') {
      const { customer, items, shipment, summary, transaction } = data
      let totalWeight = 0, weightUnit = null, awbNumber = null
      //modify package payload
      for (let pkg in packageDetails) {
        delete packageDetails[pkg]['disable-add']
        totalWeight += totalWeight+packageDetails[pkg]['weight']
        weightUnit = packageDetails[pkg]['weight-unit']
      }
      if (shippingPartnerId == 2) {
        let aramexShippingPayload = {
          quantity: packageDetails.length,
          weightUnit: weightUnit,
          weightValue: totalWeight
        }
        await axios.post(`${legolasApi.url}/admin/aramex/details`, aramexShippingPayload)
        .then(res => res.data)
        .then(data => {
          if (data.success && !data.data.HasErrors) {
            let awb = data.data.Shipments.ProcessedShipment.ID
            if (typeof awb != "undefined") {
              awbNumber = awb
            } else {
              awbNumber = null
            }
          }
        }).catch(err => {
          console.log('Error in fetching Aramex details', err)
          awbNumber = null
        })
      } else {
        if (summary && summary.order_id) {
          awbNumber = summary.order_id
        } 
      }
      if (awbNumber != null) {
          let submitPaylod = {
            orderId: summary.order_id ? summary.order_id : '',
            packages: Object.keys(packageDetails).length > 0 ? packageDetails : null,
            shipmentLabel: null,
            shippingId: shippingPartnerId,
            totalWeight: totalWeight,
            items: items ? items : [],
            totalQuantity: summary.total_qty_ordered ? summary.total_qty_ordered : null,
            customerId: customer.id ? customer.id : null,
            billingAddress: shipment ? shipment : {},
            shippingAddress: shipment ? shipment : {},
            awbNumber: awbNumber,
            storeId: summary.magento_store_id ? summary.magento_store_id : 1,
            currentOrderStatus: summary.order_status ? summary.order_status : null
        }
        
        console.log('submit payload', submitPaylod)
        axios.post(`${legolasApi.url}/admin/shipment/add`, submitPaylod).then((res) => {
          const data = res.data
          console.log('submit ship res', data)
          if (data.success) {
            const modmessage = data.message ? data.message : 'Shipment created successfully!'
            handleAlertGen(modmessage)
          }
        }).catch(err => {
          console.log('Error creating shipment', err)
        })
      }

    } else {
      const summary = data.summary
      console.log('summary: ', summary)
      let submitPayload = {
        orderId: summary.order_id ? summary.order_id : '',
        orderDate: summary.placedOn ? summary.placedOn : '',
        orderTime: summary.orderTime ? summary.orderTime : null,
        billingAddress: shipment ? shipment : {},
        shippingAddress: shipment ? shipment : {},
        shippingMethod: data.shippingMethod,
        shippingCharges: summary.shipping_incl_tax ? summary.shipping_incl_tax : '0.0',
        items: items ? items : [],
        subtotal: summary.subtotal_incl_tax ? summary.subtotal_incl_tax : 0,
        grandTotal: summary.grand_total ? summary.grand_total : 0,
        totalVat: summary.total_tax ? summary.total_tax : 0,
        storeId: summary.magento_store_id ? summary.magento_store_id : null,
        currentOrderStatus: summary.order_status ? summary.order_status : null,
        orderStatus: summary.order_status ,
        channelId: summary.channel_id
      }
      axios.post(`${legolasApi.url}/admin/invoice/add`, submitPayload).then((res) => {
        console.log('Submit invoice res: ', res)
        const data = res.data
        if (data.success) {
          handleAlertGen(data.message)
        }
      }).catch((error) => {
        console.log('Error in submit res: ', error)
      })
    }
  }

  const updateShippingPartner = async (shippingId) => {
    try {
      const { summary } = data
      const orderId = summary.order_id
      let updatePayload = { orderId: orderId, shippingId: shippingId }
      //let testPayload = { orderId: orderId, shippingId: 3 }
      await axios.post(`${legolasApi.url}/orders/shipping/partner/update`, updatePayload)
      .then(res => res.data).then(data => {
        if (data.success) {
          console.log('shipping partner ID successfully updated', updatePayload)
          setShippingPartnerId(shippingId)
        }
      }).catch(err => {
        console.log('Error 1: ', err)
      })
    } catch (err) {
      console.log('Error 2: ', err)
    }
  }

  const closePackage = () => {
    setOpenPackage(false)
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      backClickHandler()
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }

  const purchasedFromDefault = 'Shababuna Website'
  const purchasedIPDefault = 'NULL'
  // const computedGrandTotal = (parseFloat(summary.grand_total) || 0) + (parseFloat(summary.one_day_delivery_charge) || 0);

  if (data === null) return null

  return (
    <Box sx={{ height: 'auto', margin: '10px 20px'}}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex'}}>
        {
          pageType === 'shipment' ?
          <Typography variant='h4'>New Shipment</Typography> :
          <Typography variant='h4'>New Invoice</Typography>
        }
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
        }}
        >
          <Button onClick={() => backClickHandler()}>Back</Button>
          <Button>Reset</Button>
        </Box>
        {
          pageType == 'shipment' &&
            <Box id='shipping-select-container'>
            <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Select Shipping Partner</Typography>
            </Box>
            <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              justifyContent: 'center', 
              padding: '15px 0px',
              '& .MuiSelect-select': {
                width: '250px',
                borderRadius: '0px',
                border: '1px solid #000'
              } 
            }}>
              <Select 
                value={shippingPartnerId} 
                label='Select Shipping Partner' 
                onChange={e => updateShippingPartner(e.target.value)}
              >
                <MenuItem value={2}>Aramex Shipping</MenuItem>
                <MenuItem value={1}>Shababuna Shipping</MenuItem>
              </Select>
            </Box>
          </Box>
        }
        <Box id='order-container'>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Order & Account Information</Typography>
          </Box>
          <Grid container spacing={5} columns={24}>
            <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Order # {summary.order_id} (The order confirmation email was sent)
            </Typography>
            <Box sx={darkBox}>
              <Typography>Order Date</Typography>
              <Typography>{summary.placedOn}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Order Status</Typography>
              {summary.order_status ?
              <Typography>{summary.order_status}</Typography> : <Typography sx={{ color: 'red' }}>Order status not set</Typography>}
            </Box>
            <Box sx={darkBox}>
              <Typography>Channel</Typography>
              {summary.channel ?
              <Typography>{summary.channel}</Typography> : <Typography>{null}</Typography>}
            </Box>
             <Box sx={lightBox}>
              <Typography>Same Day Delivery </Typography>
              <Typography>{Number(summary.one_day_delivery_charge) > 0 ? "True" : "False"}</Typography>
                </Box>
            {/*<Box sx={lightBox}>
              <Typography>Purchased From IP</Typography>
              {summary.order_ip ?
              <Typography>{summary.order_ip}</Typography> : <Typography>{purchasedIPDefault}</Typography>}
              </Box>*/}
            </Grid>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Account Information
              </Typography>
              <Box sx={darkBox}>
                <Typography>Customer Name</Typography>
                <Typography>{shipment.customer_firstname + ' ' + shipment.customer_lastname}</Typography>
              </Box>
              {/* <Box sx={lightBox}>
                <Typography>Email</Typography>
                {shipment.email ?
                <Typography>{shipment.email}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
              </Box> */}
              <Box sx={lightBox}>
                <Typography>Phone</Typography>
                {shipment.phone_ext && shipment.phone ?
                <Typography>{shipment.phone_ext + shipment.phone}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
              </Box>
              <Box sx={darkBox}>
                <Typography>Customer Group</Typography>
                <Typography>GENERAL</Typography>
                {/*{customer.user_group_code ?
                <Typography>{customer.user_group_code}</Typography> : <Typography sx={{ color: 'red' }}>Group not set</Typography>}*/}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box id='address-container' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Address Information</Typography>
          </Box>
          <Grid container spacing={5} columns={24}>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Billing Address
              </Typography>
              <Box>
                {shipment.customer_firstname && shipment.customer_lastname ? 
                  <Typography>
                    {shipment.customer_firstname + ' ' + shipment.customer_lastname}
                  </Typography> : 
                    null
                }
              </Box>
              <Box>
                {shipment.street ? 
                  <Typography>{shipment.street}</Typography> : null
                }
              </Box>
              <Box>
                {shipment.city && shipment.district ? 
                <Typography>
                  {shipment.city + ', ' + shipment.district}
                </Typography> :
                null}
              </Box>
              <Box>
                {shipment.country ? <Typography>{shipment.country}</Typography> : null}
              </Box>
              <Box>
                {shipment.phone_ext && shipment.phone ? 
                <Typography>
                  T : {shipment.phone_ext + shipment.phone}
                </Typography> : 
                null}
              </Box>
              <Box>
              {shipment.po_number !== null &&
                  <Typography> PO: {shipment.po_number ?  shipment.po_number : null}</Typography>
              }
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Shipping Address
              </Typography>
              <Box>
                {shipment.customer_firstname && shipment.customer_lastname ? 
                  <Typography>
                    {shipment.customer_firstname + ' ' + shipment.customer_lastname}
                  </Typography> : 
                    null
                }
              </Box>
              <Box>
                {shipment.street ? 
                  <Typography>{shipment.street}</Typography> : null
                }
              </Box>
              <Box>
                {shipment.city && shipment.district ? 
                <Typography>
                  {shipment.city + ', ' + shipment.district}
                </Typography> :
                null}
              </Box>
              <Box>
                {shipment.country ? <Typography>{shipment.country}</Typography> : null}
              </Box>
              <Box>
                {shipment.phone_ext && shipment.phone ? 
                <Typography>
                  T : {shipment.phone_ext + shipment.phone}
                </Typography> : 
                null}
              </Box>
              <Box>
              {shipment.po_number !== null &&
                  <Typography> PO: {shipment.po_number ?  shipment.po_number : null}</Typography>
              }
              </Box>
              
            </Grid>
          </Grid>
        </Box>
        <Box id='payment-container' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Payment & Shipping Method</Typography>
          </Box>
          <Grid container spacing={5} columns={24}>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Payment Information
              </Typography>
              <Box>
                {transaction.paymentBrand == 'COD' ? 
                <Typography>
                  {'Cash On Delivery'}
                </Typography> : 
                <Box>
                  <Typography>{'Online Payment'}</Typography>
                  <Typography>
                    {transaction.paymentType}
                  </Typography>
                  <Typography>
                    {transaction.last4Digits}
                  </Typography>
                </Box>
                }
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Shipping Information
              </Typography>
              <Box>
              <Typography>
                {[summary.shippingId] == 2 ? 'Aramex Shipping' : 'Shababuna Shipping'}
              </Typography>
            </Box>
              <Box>
                <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontWeight: 500 }}>
                  Total Shipping Charges: <Typography sx={{ fontSize: '1.1rem', fontWeight: 700 }}>SAR {summary.shipping_incl_tax}</Typography>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box id='items-container' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            {
              pageType === 'shipment' ?
              <Typography variant='h6'>Items to Ship</Typography> :
              <Typography variant='h6'>Items to Invoice</Typography>
            }
          </Box>
          <Box>
          <TableContainer component={Paper} sx={{ paddingTop: '30px' }}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">Product</StyledTableCell>
            <StyledTableCell align="center">Product ID</StyledTableCell>
            <StyledTableCell align="center">Product Mage ID</StyledTableCell>
            <StyledTableCell align="center">Price</StyledTableCell>
            <StyledTableCell align="center">Quantity</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <StyledTableRow key={item.id}>
              <StyledTableCell component="th" scope="row">
                {item.name}
              </StyledTableCell>
              <StyledTableCell align="center">{item.id}</StyledTableCell>
              <StyledTableCell align="center">{item.mageId}</StyledTableCell>
              <StyledTableCell align="center">{item.price_incl_tax}</StyledTableCell>
              <StyledTableCell align="center">{item.quantity}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
          </Box>
        </Box>
        <Box id='total-container' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            {
              pageType === 'shipment' ?
              <Typography variant='h6'>Shipment Total</Typography> :
              <Typography variant='h6'>Order Total</Typography>
            }
          </Box>
          <Grid container spacing={5} columns={24} sx={{ flexDirection: 'row-reverse' }}>
            {/* <Grid item xs={12}>
              {
                pageType === 'shipment' ?
                <Typography variant='subtitle1' sx={subHeader}>
                  Shipment Comments
                </Typography> :
                <Typography variant='subtitle1' sx={subHeader}>
                  Invoice Comments
                </Typography>
              }
              <Box>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={5}
                placeholder={pageType == 'shipment' ? 'Shipment Comments' : 'Invoice Comments'}
                style={{ width: 500 }}
              />
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              {
                pageType === 'shipment' ?
                <Typography variant='subtitle1' sx={subHeader}>
                  Shipment Options
                </Typography> :
                <Typography variant='subtitle1' sx={subHeader}>
                  Invoice Totals
                </Typography>
              }
              {
                pageType === 'shipment' ?
                <Box>
                  <Button sx={globalStyles.shippingOptionsButton} onClick={() => setOpenPackage(true)}>Create Shipping Label</Button>
                  <Modal
                    open={openPackage}
                    onClose={closePackage}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <CreatePackage closePackage={closePackage} setPackageDetails={setPackageDetails} items={items}/>
                  </Modal>
                  <Button sx={globalStyles.shippingOptionsButton}>Append Comments</Button>
                </Box> :
                <Box sx={{ paddingBottom: '10px' }}>
                  <Box sx={darkBox}>
                    <Typography>Subtotal (incl. Tax)</Typography>
                      {summary.subtotal_incl_tax ? 
                        <Typography>
                          SAR {parseFloat(summary.subtotal_incl_tax).toFixed(2)}
                        </Typography> : <Typography sx={{ color: 'red'}}>Subtotal not set</Typography>}
                  </Box>
                  <Box sx={lightBox}>
                    <Typography>Tax</Typography>
                    <Typography>
                      SAR {parseFloat(summary.total_tax).toFixed(2)}
                    </Typography>
                  </Box>
{/*               
              <Box sx={darkBox}>
                <Typography>Coupon Discount</Typography>
                <Typography>SAR {summary.discount_amount ? parseFloat(summary.discount_amount).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box> */}
             {Number(summary.total_discount) > 0 || Number(summary.discount_amount) > 0 ? (
                                            <>
                           <Box sx={darkBox}>
                          <Typography>Total Savings</Typography>
                            <Typography>SAR {((parseFloat(summary.total_discount) || 0) + (parseFloat(summary.discount_amount) || 0)).toFixed(2)}</Typography>
                          </Box>
                          </>
                          ) : null}             
                  <Box sx={lightBox}>
                    <Typography>Shipping & Handling</Typography>
                    <Typography>
                      SAR {parseFloat(summary.shipping_incl_tax).toFixed(2)}
                    </Typography>
                  </Box>
                  
                  <Box sx={darkBox}>
                    <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                      {summary.cod_fee_incl_tax || summary.cod_fee_incl_tax == +0 ? 
                    <Typography>
                      SAR {parseFloat(summary.cod_fee_incl_tax).toFixed(2)}
                    </Typography> : <Typography sx={{ color: 'red'}}>COD fee not set</Typography>}
                  </Box>
                  {Number(summary.one_day_delivery_charge) > 0 && (
                   <Box sx={lightBox}>
                      <Typography>Next Day Delivery Fee</Typography>
                      <Typography>
                        SAR {parseFloat(summary.one_day_delivery_charge).toFixed(2)}
                      </Typography>
                    </Box>
                  )}
                  <Box sx={lightBox}>
                    <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>Grand Total</Typography>
                    {summary.grand_total ?
                      <Typography>
                        SAR {parseFloat(summary.grand_total).toFixed(2)}
                        {/* <Typography>SAR {computedGrandTotal.toFixed(2)}</Typography> */}
                      </Typography> : <Typography sx={{ color: 'red' }}>Grand Total not set</Typography>}
                  </Box>
                </Box>
              }
              <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button 
                  sx={{ 
                    backgroundColor: '#2b3f7a !important', 
                    borderRadius: 0, 
                    padding: '15px 20px', 
                    color: '#fff',
                    textTransform: 'capitalize'
                  }}
                  onClick={() => handleInvoiceorShipmentSubmit()}
                >
                  {
                    pageType === 'shipment' ?
                    <Typography>Submit Shipment</Typography> :
                    <Typography>Submit Invoice</Typography>
                  }
                </Button>
              </Box>
              </Grid>
          </Grid>
        </Box>
    </Box>
  )
}

export default AddInvoice